import { createElement, Component, createRef } from 'react';
import Editor from '@monaco-editor/react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
const AntIcon = createElement(LoadingOutlined, { style: { fontSize: 24 }, spin: true });
export default class MonacoInput extends Component {
    constructor(props) {
        super(props);
        this.editorRef = createRef();
    }
    getValue() {
        return this.editorRef.current.getValue();
    }
    getEditorInstance() {
        return this.editorRef.current;
    }
    onEditorMount(editor, monaco) {
        this.editorRef.current = editor;
        this.props?.onEditorDidMount?.(editor, monaco);
    }
    onEditorChange(value) {
        this.props?.onChange?.(value);
    }
    render() {
        const { defaultLanguage, height, theme = 'light', readOnly = false, options, loading, } = this.props;
        const value = this.props.value || this.props.defaultValue;
        return (createElement(Spin, { indicator: AntIcon, spinning: !!loading },
            createElement(Editor, { options: {
                    ...(options || {}),
                    readOnly,
                }, theme: theme, defaultLanguage: defaultLanguage || 'javascript', height: typeof height === 'string' ? parseInt(height) : height, value: value, onChange: this.onEditorChange.bind(this), onMount: this.onEditorMount.bind(this) })));
    }
}
